let statusConfigs = null;

export const setStatusConfigs = (configs) => {
  statusConfigs = configs || null;
};

export const getStatusConfigs = () => statusConfigs;
